<div class="list-container">
    <div class="list-content">
        <div class="list-details">
            <h4 class="list-details-title">Add Customer Product Price</h4>
            <div [formGroup]="addCustomerProductPriceForm">
                <div class="row">
                    <div class="col-md-12 col-lg-12">
                        <div class="form-group">
                            <label>Product <span class="required-field">*</span></label>
                            <div >
                                <p-dropdown 
                                [style]="{'minWidth':'100%'}"
                                [options]="products" 
                                [(ngModel)]="selectedProduct" 
                                placeholder="select a product" 
                                [editable]="false"
                                [filter]="true"
                                [ngModelOptions]="{standalone: true}"
                                optionLabel="name"></p-dropdown>
                            </div>

                        </div>
                        <div class="form-group">
                            <label>Customer <span class="required-field">*</span></label>
                            <div >
                                <p-multiSelect 
                                [style]="{'minWidth':'100%'}"
                                [options]="customers" 
                                [(ngModel)]="selectedCustomers" 
                                placeholder="select a customers" 
                                [ngModelOptions]="{standalone: true}"
                                optionLabel="name"></p-multiSelect>
                            </div>
                        </div>
                        <div class="form-group">
                            <label>UOM <span class="required-field">*</span></label>
                            <div >
                                <p-dropdown 
                                [style]="{'minWidth':'100%'}"
                                [options]="uoms" 
                                [(ngModel)]="selectedUOM" 
                                placeholder="select a uom" 
                                [editable]="false"
                                [filter]="true"
                                [ngModelOptions]="{standalone: true}"
                                optionLabel="uomName"></p-dropdown>
                            </div>
                        </div>
                        <div class="form-group">
                            <label>Min Qty <span class="required-field">*</span></label>
                            <input formControlName="minQty" type="text" class="form-control">
                            <span class="err" *ngIf="addCustomerProductPriceForm.get('minQty').invalid && formSubmit">min qty required</span>
                        </div>
                        <div class="form-group">
                            <label>Max Qty <span class="required-field">*</span></label>
                            <input formControlName="maxQty" type="text" class="form-control">
                            <span class="err" *ngIf="addCustomerProductPriceForm.get('maxQty').invalid && formSubmit">department name required</span>
                        </div>
                        <div class="form-group">
                            <label>Per Unit Price <span class="required-field">*</span></label>
                            <input formControlName="perUnitPrice" type="text" class="form-control">
                            <span class="err" *ngIf="addCustomerProductPriceForm.get('perUnitPrice').invalid && formSubmit">per unit price required</span>
                        </div>
                    </div>


                    
               
                </div>
            </div>
            <div class="submit-block">
                <button type="button" (click)="addCustomerProductPrice()" class="btn btn-primary">Submit</button>
            </div>
        </div>
    </div>
</div>